import React from "react";
import { connect } from "react-redux";
import ReactTooltip from 'react-tooltip'

import NameAndRating from '../Commons/NameAndRating';
import defaultAvatar from '../../../images/default-avatar.jpg'
import {getCurrentUser} from '../../../actions/session';

class MyPortfolioIndividual extends React.Component {

    componentDidMount() {
        this.props.dispatch(getCurrentUser(
            this.props.session.token,
            () => console.log('ok!'),
            true
        ));
    }

    render() {

        const { avatar } = this.props;
        
        return (
            <div className="tab-content profile-info tab-content1">

                <div className="human-info">
                    {
                        avatar
                        ? <div className="human-info-avatar" style={{ backgroundImage: `url(${window.siteUrl}${avatar})` }} />
                        : <div className="human-info-avatar" style={{ backgroundImage: `url(${defaultAvatar})` }} />
                    }
                    <div className="base-info">
                        
                        <NameAndRating {...this.props} />

                        <div className="human-contacts">
                            {
                                this.props.phone ?
                                <div className="phone contact-info">
                                    {this.props.phone}

                                    <div style={{height:'28px'}}>
                                        <span className={`info-tooltip confirmed__icon ${this.props.is_phone_confirmed ? 'active' : ''}`} data-tip data-for='phone' />
                                        <ReactTooltip id='phone' type='dark'>
                                            <span>
                                                {
                                                    this.props.is_phone_confirmed
                                                    ? 'Телефонный номер подтвержден'
                                                    : 'Телефонный номер не подтвержден'
                                                }
                                            </span>
                                        </ReactTooltip>
                                    </div>
                                </div>
                                : null
                            }
                            {
                                this.props.username ? 
                                <div className="email contact-info">
                                    {this.props.username}
                                
                                    <div style={{height:'28px'}}>
                                        <span className={`info-tooltip confirmed__icon ${this.props.is_email_confirmed ? 'active' : ''}`} data-tip data-for='email' />
                                        <ReactTooltip id='email' type='dark'>
                                            <span>
                                                {
                                                    this.props.is_email_confirmed
                                                    ? 'Электронная почта подтверждена'
                                                    : 'Электронная почта не подтверждена'
                                                }
                                            </span>
                                        </ReactTooltip>
                                    </div>
                                </div>
                                : null
                            }
                            {this.props.socnet_vk ? (<div className="msg contact-info">{this.props.socnet_vk}</div>) : '' }
                        </div>
                    </div>
                    <div className="city">
                        {this.props.city ? ( <span>г. {this.props.city}</span>) : '' }
                    </div>
                </div>

                <div className="human-about-info">
                    {this.props.content ? this.props.content : '' }
                </div>

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(mapStateToProps)(MyPortfolioIndividual);


// WEBPACK FOOTER //
// ./src/components/Profile/SubMyPortfolio/MyPortfolioIndividual.js